import type { ProductFleetBannerContent } from "~/data/products/types";

// The site-wide "Managing a Fleet?" banner copy, in the `home` namespace. Shared by the home
// page and /products so the two can't drift; render it with FleetBannerSection namespace="home".
export const HOME_FLEET_BANNER: ProductFleetBannerContent = {
  headline: "fleet_banner.headline",
  description: "fleet_banner.description",
  ctaLabel: "fleet_banner.cta_label",
  ariaLabel: "fleet_banner.aria_label",
  ctaHref: "/fleet",
};
